export const liveCallTasksAction = {
  countLiveCallTodoTasks: (state, action) => {
    state.shouldCountLiveCallTodoTasks = action.payload;
  },
};
